import React, { FunctionComponent } from 'react'
import { Pressable } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { BodyText, Size as BodyTextSize } from '../../atoms/bodyText/BodyText'
import { Image } from '../../atoms/image/Image'
import { Subhead, Size as SubheadSize } from '../../atoms/subhead/Subhead'
import { tID } from '../../utils/utils'

export interface EssentialsBubbleProps {
  title: string
  url: string
  thumbnailURI: string
  articleTypeLabel: string
  readTime: string
  onEssentialsPress: (url: string) => void
}

const Container = styled(Pressable)(({ theme }) => ({
  flexDirection: 'row',
  borderRadius: '16px',
  border: `1px solid ${theme.colors.borderDefault}`,
  padding: theme.spacing['12px'],
  backgroundColor: theme.colors.backgroundPrimary,
  marginTop: theme.spacing['12px'],
  cursor: 'pointer',
}))

const ContentContainer = styled.View(() => ({
  flexShrink: 1,
}))

const Thumbnail = styled(Image)(({ theme }) => ({
  borderRadius: '8px',
  height: '64px',
  width: '64px',
  marginRight: theme.spacing['12px'],
}))

const Title = styled(Subhead)(({ theme }) => ({
  marginBottom: theme.spacing['8px'],
}))

export const EssentialsBubble: FunctionComponent<EssentialsBubbleProps> = ({
  title,
  url,
  thumbnailURI,
  articleTypeLabel,
  readTime,
  onEssentialsPress,
}) => {
  const { colors } = useTheme()

  const handlePress = (url: string) => {
    const urlObj = new URL(url)
    const essentialArticle = urlObj.pathname.split('/').pop() || ''
    onEssentialsPress(essentialArticle)
  }

  return (
    <Container
      testID={tID('EssentialsBubble')}
      accessibilityRole='button'
      accessibilityLabel={title}
      onPress={() => handlePress(url)}
      style={({ hovered }) => ({
        backgroundColor: hovered ? colors.backgroundElement : colors.backgroundPrimary,
      })}
    >
      <Thumbnail source={`https://${thumbnailURI}`} />
      <ContentContainer>
        <Title text={title} size={SubheadSize.XSMALL} />
        <BodyText
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          text={`${articleTypeLabel}  •  ${readTime}`}
          size={BodyTextSize.CAPTION}
          color={colors.textSecondary}
        />
      </ContentContainer>
    </Container>
  )
}
